import { attachTabSync } from '@rocketlane/state-db';
import { getTabSync } from '../tab-sync';
import { timesheetCollection } from './timesheet-collection';
export const attachTimesheetTabSync = ()=>attachTabSync({
        collection: timesheetCollection,
        sync: getTabSync()
    });
